import { Link } from "react-router-dom";
import "../styles/content-page.scss";
import Nav from "./Nav";
import Footer from "./Footer";
import PageMeta from "./PageMeta";
import { FadeInUp } from "./motion";
import { organizationSchema } from "../content/seo";

const notFoundMeta = {
  title: "Page not found | Pawwash",
  description: "The page you are looking for could not be found.",
  path: "/404",
  robots: "noindex, nofollow",
};

const NotFound = () => {
  return (
    <main className="not-found">
      <PageMeta meta={notFoundMeta} jsonLd={organizationSchema} />
      <Nav page="" />
      <FadeInUp as="header" className="page-hero">
        <h1>Page not found</h1>
        <p>Sorry, we could not find that page.</p>
        <Link to="/" className="not-found__link">
          Return to home
        </Link>
      </FadeInUp>
      <Footer />
    </main>
  );
};

export default NotFound;
